export default __webpack_public_path__ + "static/media/co-work-black.619b2554.svg";